// Geografidatasett for sponsor-målretting og brukersted (kommune/fylke).
//
// Hentet fra https://norgeskommuner.no/fylke og de 15 tilhørende
// /fylke/<navn>-sidene (26.07.2026). Samiske/kvenske parallellnavn (f.eks.
// «Guovdageaidnu - Kautokeino», «Deatnu - Tana») er forenklet til det norske
// navnet alene, siden dropdown-valget her kun trenger étt entydig navn per
// kommune.
//
// FYLKER er de 15 fylkene (gjeldende inndeling siden 01.01.2024).
// KOMMUNER_BY_FYLKE kobler hvert fylke til dets kommuner, slik at man i UI
// først velger fylke, og deretter kun får velge blant kommunene i det fylket.

export const FYLKER: string[] = [
  'Østfold',
  'Akershus',
  'Oslo',
  'Innlandet',
  'Buskerud',
  'Vestfold',
  'Telemark',
  'Agder',
  'Rogaland',
  'Vestland',
  'Møre og Romsdal',
  'Trøndelag',
  'Nordland',
  'Troms',
  'Finnmark',
];

export const KOMMUNER_BY_FYLKE: Record<string, string[]> = {
  'Østfold': [
    'Aremark', 'Fredrikstad', 'Halden', 'Hvaler', 'Indre Østfold', 'Marker', 'Moss', 'Rakkestad', 'Råde', 'Sarpsborg', 'Skiptvet', 'Våler (Østfold)',
  ],
  'Akershus': [
    'Asker', 'Aurskog-Høland', 'Bærum', 'Eidsvoll', 'Enebakk', 'Frogn', 'Gjerdrum', 'Hurdal', 'Jevnaker', 'Lillestrøm', 'Lunner', 'Lørenskog', 'Nannestad', 'Nes', 'Nesodden', 'Nittedal', 'Nordre Follo', 'Rælingen', 'Ullensaker', 'Vestby', 'Ås',
  ],
  'Oslo': ['Oslo'],
  'Innlandet': [
    'Alvdal', 'Dovre', 'Eidskog', 'Elverum', 'Engerdal', 'Etnedal', 'Folldal', 'Gausdal', 'Gjøvik', 'Gran', 'Grue', 'Hamar', 'Kongsvinger', 'Lesja', 'Lillehammer', 'Lom', 'Løten', 'Nord-Aurdal', 'Nord-Fron', 'Nord-Odal', 'Nordre Land', 'Os', 'Rendalen', 'Ringebu', 'Ringsaker', 'Sel', 'Skjåk', 'Stange', 'Stor-Elvdal', 'Søndre Land', 'Sør-Aurdal', 'Sør-Fron', 'Sør-Odal', 'Tolga', 'Trysil', 'Tynset', 'Vang', 'Vestre Slidre', 'Vestre Toten', 'Vågå', 'Våler (Innlandet)', 'Østre Toten', 'Øyer', 'Øystre Slidre', 'Åmot', 'Åsnes',
  ],
  'Buskerud': [
    'Drammen', 'Flesberg', 'Flå', 'Gol', 'Hemsedal', 'Hol', 'Hole', 'Kongsberg', 'Krødsherad', 'Lier', 'Modum', 'Nesbyen', 'Nore og Uvdal', 'Ringerike', 'Rollag', 'Sigdal', 'Øvre Eiker', 'Ål',
  ],
  'Vestfold': ['Færder', 'Holmestrand', 'Horten', 'Larvik', 'Sandefjord', 'Tønsberg'],
  'Telemark': [
    'Bamble', 'Drangedal', 'Fyresdal', 'Hjartdal', 'Kragerø', 'Kviteseid', 'Midt-Telemark', 'Nissedal', 'Nome', 'Notodden', 'Porsgrunn', 'Seljord', 'Siljan', 'Skien', 'Tinn', 'Tokke', 'Vinje',
  ],
  'Agder': [
    'Arendal', 'Birkenes', 'Bygland', 'Bykle', 'Evje og Hornnes', 'Farsund', 'Flekkefjord', 'Froland', 'Gjerstad', 'Grimstad', 'Hægebostad', 'Iveland', 'Kristiansand', 'Kvinesdal', 'Lillesand', 'Lindesnes', 'Lyngdal', 'Risør', 'Sirdal', 'Tvedestrand', 'Valle', 'Vegårshei', 'Vennesla', 'Åmli', 'Åseral',
  ],
  'Rogaland': [
    'Bjerkreim', 'Bokn', 'Eigersund', 'Gjesdal', 'Haugesund', 'Hjelmeland', 'Hå', 'Karmøy', 'Klepp', 'Kvitsøy', 'Lund', 'Randaberg', 'Sandnes', 'Sauda', 'Sokndal', 'Sola', 'Stavanger', 'Strand', 'Suldal', 'Time', 'Tysvær', 'Utsira', 'Vindafjord',
  ],
  'Vestland': [
    'Alver', 'Askvoll', 'Askøy', 'Aurland', 'Austevoll', 'Austrheim', 'Bergen', 'Bjørnafjorden', 'Bremanger', 'Bømlo', 'Eidfjord', 'Etne', 'Fedje', 'Fitjar', 'Fjaler', 'Gloppen', 'Gulen', 'Hyllestad', 'Høyanger', 'Kinn', 'Kvam', 'Kvinnherad', 'Luster', 'Lærdal', 'Masfjorden', 'Modalen', 'Osterøy', 'Samnanger', 'Sogndal', 'Solund', 'Stad', 'Stord', 'Stryn', 'Sunnfjord', 'Sveio', 'Tysnes', 'Ullensvang', 'Ulvik', 'Vaksdal', 'Vik', 'Voss', 'Øygarden', 'Årdal',
  ],
  'Møre og Romsdal': [
    'Aukra', 'Aure', 'Averøy', 'Fjord', 'Giske', 'Gjemnes', 'Haram', 'Hareid', 'Herøy (Møre og Romsdal)', 'Hustadvika', 'Kristiansund', 'Molde', 'Rauma', 'Sande', 'Smøla', 'Stranda', 'Sula', 'Sunndal', 'Surnadal', 'Sykkylven', 'Tingvoll', 'Ulstein', 'Vanylven', 'Vestnes', 'Volda', 'Ørsta', 'Ålesund',
  ],
  'Trøndelag': [
    'Flatanger', 'Frosta', 'Frøya', 'Grong', 'Heim', 'Hitra', 'Holtålen', 'Høylandet', 'Inderøy', 'Indre Fosen', 'Leka', 'Levanger', 'Lierne', 'Malvik', 'Melhus', 'Meråker', 'Midtre Gauldal', 'Namsos', 'Namsskogan', 'Nærøysund', 'Oppdal', 'Orkland', 'Osen', 'Overhalla', 'Rennebu', 'Rindal', 'Røros', 'Røyrvik', 'Selbu', 'Skaun', 'Snåsa', 'Steinkjer', 'Stjørdal', 'Trondheim', 'Tydal', 'Verdal', 'Ørland', 'Åfjord',
  ],
  'Nordland': [
    'Alstahaug', 'Andøy', 'Beiarn', 'Bindal', 'Bodø', 'Brønnøy', 'Bø', 'Dønna', 'Evenes', 'Fauske', 'Flakstad', 'Gildeskål', 'Grane', 'Hadsel', 'Hamarøy', 'Hattfjelldal', 'Hemnes', 'Herøy (Nordland)', 'Leirfjord', 'Lurøy', 'Lødingen', 'Meløy', 'Moskenes', 'Narvik', 'Nesna', 'Rana', 'Rødøy', 'Røst', 'Saltdal', 'Sortland', 'Steigen', 'Sømna', 'Sørfold', 'Træna', 'Vefsn', 'Vega', 'Vestvågøy', 'Vevelstad', 'Værøy', 'Vågan', 'Øksnes',
  ],
  'Troms': [
    'Balsfjord', 'Bardu', 'Dyrøy', 'Gratangen', 'Harstad', 'Ibestad', 'Karlsøy', 'Kvæfjord', 'Kvænangen', 'Kåfjord', 'Lavangen', 'Lyngen', 'Målselv', 'Nordreisa', 'Salangen', 'Senja', 'Skjervøy', 'Storfjord', 'Sørreisa', 'Tjeldsund', 'Tromsø',
  ],
  'Finnmark': [
    'Alta', 'Berlevåg', 'Båtsfjord', 'Gamvik', 'Hammerfest', 'Hasvik', 'Karasjok', 'Kautokeino', 'Lebesby', 'Loppa', 'Måsøy', 'Nesseby', 'Nordkapp', 'Porsanger', 'Sør-Varanger', 'Tana', 'Vadsø', 'Vardø',
  ],
};
